export default "__VITE_ASSET__PySTe8ni__"